module.exports = __webpack_public_path__ + "static/media/value-prop-3.6b985ba0.png";